(function(Drupal) {
  Drupal.behaviors.stickyNerivioButton = {
    attach(context) {
      const excludedPaths = ['/about-us', '/press', '/contact-us-patient', '/terms-use', '/privacy-policy', '/cookie-policy'];
      if (excludedPaths.includes(window.location.pathname) || window.location.pathname.includes('/layout')) return;
      const block = context.querySelector('.logos-block') || document.querySelector('.logos-block');
      const footer = document.querySelector('.footer.footer-nerivio');
      let wrapper;
      if (document.querySelector('.sticky-nerivio-wrapper')) return;

      // Inject CSS once
      if (!document.getElementById('sticky-nerivio-style')) {
        const style = document.createElement('style');
        style.id = 'sticky-nerivio-style';
        style.innerHTML = `
          .sticky-nerivio-wrapper {
            position: fixed !important;
            bottom: 0;
            left: 50%;
            transform: translateX(-50%);
            z-index: 9999;
            background-color: rgba(245, 245, 245, 1);
            padding: 10px 20px;
            border-radius: 8px;
            width: 100%;
            text-align: center;
            transition: opacity 0.3s ease;
            box-shadow: 0px -3px 42px -4px rgba(46, 46, 46, 0.18);
          }
          .external-btn-clone {
            font-family: 'DRL Circular';
            font-weight: 700;
            font-size: 16px;
            height: 48px;
            line-height: 1;
            display: inline-block;
            top: unset !important;
            width: 321px !important;
            border-radius: 25px;
            background-color: #A4DBB3;
            padding: 14px 24px;
            transition: background-color 0.3s ease, color 0.3s ease;
            color: #383743;
            text-decoration: none;
            display: flex;
            justify-content: center;
            align-items: center;
            margin: 0 auto;
            @media screen and (min-width: 768px) {
              height: 48px;
              width: 345px !important;
            }
          }
          .cc-window.cc-banner.cc-type-opt-in.cc-theme-block.cc-bottom {
            z-index: 999999999;
          }
          .external-btn-clone:hover {
            background-color: #383743;
            color: #F5F5F5;
          }
          .external-btn-clone::after {
            content: '';
            background-image: url('/themes/custom/drl_nerivio_uk/dist/app-drupal/images/external-arrow.svg');
            background-repeat: no-repeat;
            background-position: center;
            width: 40px;
            height: 10px;
            display: inline-block;
            margin-left: 8px;
            transition: background-image 0.3s ease;
          }
          .external-btn-clone:hover::after {
            background-image: url('/themes/custom/drl_nerivio_uk/dist/app-drupal/images/external-arrow-white.svg');
          }

          /* Desktop hide class */
          @media (min-width: 992px) {
            .sticky-hide-desktop {
              display: none !important;
            }
          }

          @media (min-width: 1200px) {
            .external-btn-clone {
              width: 688px !important;
              height: 57px;
              padding: 16px 24px;
              font-size: 20px;
            }

            .external-btn-clone::after {
              margin-left: 16px;
            }
          }
        `;
        document.head.appendChild(style);
      }

      let stickyShown = false;

      function maybeShowStickyButton() {
        if (document.querySelector('.sticky-nerivio-wrapper')) return;
        const scrollPercent = window.scrollY / (document.documentElement.scrollHeight - window.innerHeight);
        if (stickyShown || scrollPercent < 0.05) return;
        if (block) {
          const rect = block.getBoundingClientRect();
          if (rect.top > window.innerHeight) return;
        }

        wrapper = document.createElement('div');
        wrapper.className = 'sticky-nerivio-wrapper';

        // If logos-block doesn't exist, add class to hide on desktop
        if (!block) {
          wrapper.classList.add('sticky-hide-desktop');
        }

        wrapper.innerHTML = `
          <a class="btn-primary buy_nerivio external-btn-clone sticky-nerivio-clone"
            href="https://neriviodirect.co.uk/"
            id="NerivioDirect"
            aria-label="Sticky copy of Neriviodirect button">Buy Now</a>
        `;
        document.body.appendChild(wrapper);
        stickyShown = true;

        window.removeEventListener('scroll', maybeShowStickyButton);
      }

      function handleFooterVisibility() {
        if (!wrapper || !footer) return;

        const footerRect = footer.getBoundingClientRect();
        const overlap = window.innerHeight - footerRect.top;

        if (overlap > 0) {
          wrapper.style.position = 'absolute';
          wrapper.style.bottom = `${overlap}px`;
        } else {
          wrapper.style.position = 'fixed';
          wrapper.style.bottom = '0';
        }
      }

      window.addEventListener('scroll', maybeShowStickyButton);
      window.addEventListener('scroll', handleFooterVisibility);
      maybeShowStickyButton();
    }
  };
})(Drupal);
